import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { translate } from '~l10n/client';
import room from 'room';
import _ from 'underscore';
import user from 'user';

import platform from 'Platform';
import model from 'StudentHeaderModel';
import view from 'StudentHeaderView';

import popup from '../../../shared/components/popup/PopupController';

class StudentHeaderController {
  render() {
    let menuText = user.getFirstName() || translate('Menu');
    let roomName = room.getRoomName() || '';

    ReactDOM.render(
      React.createElement(view, {
        controller: controller,
        model: model,
        roomName: roomName.toUpperCase(),
        userName: menuText,
        handraiseStatus: user.getHandRaiseStatus(),
        handraise: user.getStudentHandraise(),
      }),
      document.getElementById('student-header-container'),
      controller.afterRender
    );
  }

  afterRender() {
    if (model.mobileMenuVisible) {
      let mobileMenu = document.getElementById('mobile-student-header-menu');
      setTimeout(() => {
        mobileMenu.style.right = '0';
        clearTimeout();
      }, 10);
    }
  }

  usernameClicked() {
    if (!model.accountMenuVisible) {
      _.defer(controller.usernameClickedDeferred); // Defer so the document click listener finishes first.
    }
  }

  usernameClickedDeferred() {
    model.accountMenuVisible = true;
    controller.render();
    controller.addClickListener();
  }

  addClickListener() {
    if (platform.isIos) {
      document.body.style.cursor = 'pointer';
    }
    document.body.addEventListener('click', controller.documentClicked);
  }

  documentClicked(event) {
    _.defer(() => {
      controller.removeClickListener(event); // Defer so we don't prematurely close menus (i.e. so other click events can be handled first).
    });
  }

  removeClickListener(event) {
    if (event.target.id === 'handraise-overlay') {
      return;
    }

    if (platform.isIos) {
      document.body.style.cursor = 'default';
    }

    document.body.removeEventListener('click', controller.documentClicked);
    model.accountMenuVisible = false;
    controller.render();
  }

  refreshClicked() {
    popup.render({
      title: translate('Please Confirm'),
      message: translate('Are you sure you want to refresh?'),
      buttonText: translate('Yes'),
      cancelText: translate('No'),
      buttonClicked: () => {
        window.location.reload();
      },
    });
  }

  handraiseClicked() {
    model.handraiseClicked(
      !user.getStudentHandraise(),
      controller.showStudentMenu
    );
  }

  showStudentMenu() {
    model.accountMenuVisible = true;
    controller.render();
    controller.addClickListener();
  }

  logOutClicked() {
    popup.render({
      title: translate('Please Confirm'),
      message: translate('Are you sure you want to log out?'),
      buttonText: translate('Yes'),
      cancelText: translate('No'),
      buttonClicked: () => {
        user.logout(function () {
          if (window.pubnub) {
            window.pubnub.unsubscribeAll(); // Hack to ensure pubnub cleaned up properly
          }
          window.location.href = '/login/student/';
        });
      },
    });
  }

  mobileMenuClicked() {
    if (model.mobileMenuVisible) {
      controller.hideMobileMenus();
    } else {
      model.mobileMenuVisible = true;
      document.getElementById('student-header-container').style.position =
        'fixed';
      document.getElementById('student-page-container').style.overflow =
        'hidden';
      window.addEventListener(
        'orientationchange',
        controller.orientationChanged
      );
      controller.render();
    }
  }

  /**
   * Hide the mobile header menu immediately, with no animation (see SOC-1093).
   */
  orientationChanged() {
    window.removeEventListener(
      'orientationchange',
      controller.orientationChanged
    );
    model.mobileMenuVisible = false;
    let mobileHeader = document.getElementById('mobile-student-header-menu');
    if (mobileHeader) {
      mobileHeader.style.right = '-100%';
    }
    document.getElementById('student-header-container').style.position = '';
    document.getElementById('student-page-container').style.overflow = '';
    controller.render();
  }

  hideMobileMenus() {
    if (model.mobileMenuVisible) {
      model.mobileMenuVisible = false;
      let mobileMenu = document.getElementById('mobile-student-header-menu');
      mobileMenu.style.right = '-100%';

      setTimeout(() => {
        document.getElementById('student-header-container').style.position = '';
        document.getElementById('student-page-container').style.overflow = '';
        controller.render();
        clearTimeout();
      }, 250);
    }
  }
}

let controller = new StudentHeaderController();
module.exports = controller;
